<app-embedded-toolbar (onConfigure)="scope.openConfiguration()" [configurationName]="scope.translations.HOME_CONFIG"></app-embedded-toolbar>
<div class="data-hero">
    <div class="data-hero__spotlight">
        <img src="https://prmarketing-assets.s3.us-east-1.amazonaws.com/spotlight.png"
            alt="Circle graphic with orange and pink gradient"
            width="580">
    </div>
    <div class="data-hero__image">
        <div appImgEditContainer="home"
            [path]="scope.uploadImageIcon.section2"
            name="Hero Image">
            <img [src]="scope.component.assets?.section2"
                alt="Smiling woman">
        </div>
        <div class="data-hero__hero-text"
            appTextEditContainer="home"
            name="Hero Text"
            [title]="'HERO_HEADING'"
            [body]="'HERO_SUBHEADING'">
            <div class="data-hero__heading">
                {{scope.getText | transform:'HERO_HEADING'}}
            </div>
            <p class="data-hero__subheading">
                {{scope.getText | transform:'HERO_SUBHEADING'}}
            </p>
        </div>
    </div>
</div>

<div class="job-search" disabledDiv *ngIf="!scope.config.disableJobSearchPage">
    <form class="job-search__form" (submit)="scope.search()">
        <div class="job-search__field">
            <label class="job-search__label" for="jobText">{{scope.getText | transform:'FIND_JOBS'}}</label>
            <mat-form-field appearance="outline" class="job-search__input">
                <input matInput id="jobText" name="jobText"
                    [placeholder]="scope.getText | transform:'FIND_JOBS_PLACEHOLDER'"
                    [formControl]="scope.jobText">
            </mat-form-field>
        </div>
        <div class="job-search__divider"></div>
        <div class="job-search__field">
            <label class="job-search__label" for="locSearch">{{scope.getText | transform:'NEAR_LOCATION'}}</label>
            <mat-form-field appearance="outline" class="job-search__input">
                <input matInput id="locSearch" name="locSearch"
                    [placeholder]="scope.getText | transform:'NEAR_LOCATION_PLACEHOLDER'"
                    [matAutocomplete]="auto" [formControl]="scope.selectedLocation">
            </mat-form-field>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="scope.createLocationString" (optionSelected)="scope.search()">
                <mat-option *ngFor="let location of scope.locations" [value]="location">
                    {{scope.createLocationString | transform:location}}
                </mat-option>
            </mat-autocomplete>
        </div>
        <button class="job-search__submit" type="submit">{{scope.getText | transform:'SEARCH'}}</button>
    </form>
</div>

<div class="talent-cta"
    *ngIf="scope.config.enableTalentCta !== false"
    appTextEditContainer="home"
    name="Talent CTA"
    [title]="'TALENT_CTA_HEADING'"
    [body]="'TALENT_CTA_BODY'">
    <h2 class="talent-cta__heading">{{scope.getText | transform:'TALENT_CTA_HEADING'}}</h2>
    <p class="talent-cta__body">{{scope.getText | transform:'TALENT_CTA_BODY'}}</p>
    <a routerLink="/register" class="talent-cta__button">
        {{scope.getText | transform:'JOIN_TALENT_COMMUNITY_BUTTON'}} <mat-icon inline="true">north_east</mat-icon>
    </a>
</div>

<div class="talent-video"
    *ngIf="scope.config.enableTalentVideo !== false"
    appVideoEditContainer="home"
    [currentUrl]="scope.component.assets?.video"
    name="YouTube Video">
    <h2 class="talent-video__heading"
        appTextEditContainer="home"
        name="Talent Video Heading"
        [title]="'TALENT_VIDEO_HEADING'">{{scope.getText | transform:'TALENT_VIDEO_HEADING'}}</h2>
    <div class="talent-video__embed" *ngIf="scope.component.assets?.video">
        <iframe
            [src]="getSafeVideoUrl(scope.component.assets.video)"
            [title]="scope.getText | transform:'TALENT_VIDEO_HEADING'"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
        </iframe>
    </div>
</div>
